/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as AuthRouteRouteImport } from './app/auth/route'
import { Route as IndexRouteImport } from './app/index'
import { Route as VerifyEmailIndexRouteImport } from './app/verify-email/index'
import { Route as UnsubscribeIndexRouteImport } from './app/unsubscribe/index'
import { Route as ResetPasswordIndexRouteImport } from './app/reset-password/index'
import { Route as EditorIndexRouteImport } from './app/editor/index'
import { Route as DebugIndexRouteImport } from './app/debug/index'
import { Route as DashboardIndexRouteImport } from './app/dashboard/index'
import { Route as AuthSuccessIndexRouteImport } from './app/auth/success/index'
import { Route as AuthRegisterIndexRouteImport } from './app/auth/register/index'
import { Route as AuthLoginIndexRouteImport } from './app/auth/login/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './app/auth/forgot-password/index'
import { Route as AuthGoogleCallbackIndexRouteImport } from './app/auth/google/callback/index'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeIndexRoute = UnsubscribeIndexRouteImport.update({
  id: '/unsubscribe/',
  path: '/unsubscribe/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorIndexRoute = EditorIndexRouteImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugIndexRoute = DebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSuccessIndexRoute = AuthSuccessIndexRouteImport.update({
  id: '/success/',
  path: '/success/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthGoogleCallbackIndexRoute = AuthGoogleCallbackIndexRouteImport.update({
  id: '/google/callback/',
  path: '/google/callback/',
  getParentRoute: () => AuthRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardIndexRoute
  '/debug': typeof DebugIndexRoute
  '/editor': typeof EditorIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/unsubscribe': typeof UnsubscribeIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/auth/success': typeof AuthSuccessIndexRoute
  '/auth/google/callback': typeof AuthGoogleCallbackIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardIndexRoute
  '/debug': typeof DebugIndexRoute
  '/editor': typeof EditorIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/unsubscribe': typeof UnsubscribeIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/auth/success': typeof AuthSuccessIndexRoute
  '/auth/google/callback': typeof AuthGoogleCallbackIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/debug/': typeof DebugIndexRoute
  '/editor/': typeof EditorIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/unsubscribe/': typeof UnsubscribeIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/login/': typeof AuthLoginIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/auth/success/': typeof AuthSuccessIndexRoute
  '/auth/google/callback/': typeof AuthGoogleCallbackIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/debug'
    | '/editor'
    | '/reset-password'
    | '/unsubscribe'
    | '/verify-email'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/success'
    | '/auth/google/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/debug'
    | '/editor'
    | '/reset-password'
    | '/unsubscribe'
    | '/verify-email'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/success'
    | '/auth/google/callback'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/dashboard/'
    | '/debug/'
    | '/editor/'
    | '/reset-password/'
    | '/unsubscribe/'
    | '/verify-email/'
    | '/auth/forgot-password/'
    | '/auth/login/'
    | '/auth/register/'
    | '/auth/success/'
    | '/auth/google/callback/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DebugIndexRoute: typeof DebugIndexRoute
  EditorIndexRoute: typeof EditorIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  UnsubscribeIndexRoute: typeof UnsubscribeIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/': {
      id: '/unsubscribe/'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/': {
      id: '/editor/'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof EditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/': {
      id: '/debug/'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/success/': {
      id: '/auth/success/'
      path: '/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/': {
      id: '/auth/register/'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login/': {
      id: '/auth/login/'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password/': {
      id: '/auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/google/callback/': {
      id: '/auth/google/callback/'
      path: '/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthSuccessIndexRoute: typeof AuthSuccessIndexRoute
  AuthGoogleCallbackIndexRoute: typeof AuthGoogleCallbackIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthSuccessIndexRoute: AuthSuccessIndexRoute,
  AuthGoogleCallbackIndexRoute: AuthGoogleCallbackIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DebugIndexRoute: DebugIndexRoute,
  EditorIndexRoute: EditorIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  UnsubscribeIndexRoute: UnsubscribeIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
